/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';
import { ApiDefUserData } from '../../models/api-def-user-data';

export interface OrganizationsUpdateUserRole$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the user to update
 */
  userId: string;
      body: {

/**
 * The new role for the user
 */
'role': 'owner' | 'admin' | 'viewer';
}
}

export function organizationsUpdateUserRole(http: HttpClient, rootUrl: string, params: OrganizationsUpdateUserRole$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;
'role'?: 'owner' | 'admin' | 'viewer';
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateUserRole.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'organization'?: ApiDefOrganizationData;
      'user'?: ApiDefUserData;
      'role'?: 'owner' | 'admin' | 'viewer';
      }>;
    })
  );
}

organizationsUpdateUserRole.PATH = '/organizations/{organizationId}/users/{userId}';
